/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

import {
  EmptyStateActionDirective,
  EmptyStateComponent,
  EmptyStateDescriptionDirective,
  EmptyStateIllustrationDirective,
  EmptyStateTitleDirective,
} from './empty-state.component';

export {
  EmptyStateActionDirective,
  EmptyStateComponent,
  EmptyStateDescriptionDirective,
  EmptyStateIllustrationDirective,
  EmptyStateTitleDirective,
};

export const emptyStateBundle = [
  EmptyStateActionDirective,
  EmptyStateComponent,
  EmptyStateDescriptionDirective,
  EmptyStateIllustrationDirective,
  EmptyStateTitleDirective,
] as const;
